import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Button, Input } from "antd";
import { TiUser } from "react-icons/ti";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import { initFilterInput, renderColumns } from "./constants";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import CustomTable from "../../../components/common/Table/CustomTable";
import Title from "../../../components/common/Title/Title";
import moment from "moment";
import DatePicker from "react-datepicker";
import { IoCalendarOutline } from "react-icons/io5";
import { convertJemputTerjadwal } from "../helpers/convertJemputTerjadwal";
import Select from "react-select";
import TextInfo from "../../../components/common/TextInfo/TextInfo";
import CustomDatePicker from "../helpers/CustomDatePicker";
import { GetImage } from "../../../components/helpers/GetImage";
import IsEmpty from "../../../components/helpers/IsEmpty";

export default function JemputTerjadwal() {
    const [records, setRecords] = useState([]);
    const [totalRecords, setTotalRecords] = useState();
    const [id, setId] = useState();
    const [dateValue, setDateValue] = useState([]);
    const [modalAdd, setModalAdd] = useState(false);
    const [modalCancel, setModalCancel] = useState(false);
    const [modalDetail, setModalDetail] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filterInput, setFilterInput] = useState(initFilterInput);
    const [tablePagination, setTablePagination] = useState({});
    const [codeGadai, setCodeGadai] = useState();
    const [namaNasabah, setNamaNasabah] = useState();
    const [notelpNasabah, setNotelpNasabah] = useState();
    const [kondisi, setKondisi] = useState();
    const [noImei, setNoImei] = useState();
    const [tanggalJemput, setTanggalJemput] = useState();
    const [waktuJemput, setWaktuJemput] = useState();
    const [alamatJemput, setAlamatJemput] = useState();
    const [kurir, setKurir] = useState();
    const [namakurir, setNamaKurir] = useState();
    const [barangJaminan, setBarangJaminan] = useState();
    const [images, setImage] = useState([]);
    const [outletName, setOutletName] = useState();

    const [date, setDate] = useState();
    const [alamat, setAlamat] = useState();
    const [kurirList, setKurirList] = useState([]);
    const [alasan, setAlasan] = useState("");
    const [errorReason, setErrorReason] = useState("");
    const [cancel, setCancel] = useState();


    useEffect(() => {
        getData();
        getKurir();
    }, [filterInput]);


    const getData = () => {
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up-scheduled`;
        let params = {
            search: filterInput.searchName,
            page: parseInt(filterInput.page),
            size: parseInt(filterInput.pageSize),
            start_date: filterInput.transactionStartDate,
            end_date: filterInput.transactionEndDate,
            sorting_field: filterInput.sortingField,
            sorting_order: filterInput.sortingOrder,
        };
        console.log(params)
        AxiosCustomGet(
            url,
            Config(
                {
                    Authorization: `Bearer ${Cookies.get("access_token")}`,
                },
                params
            ),

            (response) => {
                let data = response.data.data;
                setRecords(convertJemputTerjadwal(data.items));
                setTotalRecords(data.total_item);
                setLoading(false);
                setTablePagination({
                    current: response.data.data?.page,
                    pageSize: response.data.data?.per_page,
                    total: response.data.data?.total_item,
                });
            },
            (error) => {
                console.log(error);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const reset = () => {

    };

    const handleSubmit = () => {
        setSubmitting(true);

        let data = {
            gadai_id: id,
            employee_id: kurir?.id,
            address: alamat,
            pick_up_date: date,
        };

        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up/confirm`;
        httpclient
            .POST(url, data)
            .then((response) => {
                console.log(response);
                SwalToast.fire({
                    icon: "success",
                    title: response.data.message,
                });
                getData();
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data.error);
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data.error.message,
                    });
                } else {
                    console.log(error);
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            })
            .finally(() => {
                setSubmitting(false);
                window.location.reload(true);
            });
    }


    const handleDateChange = (event) => {
        const startDate = moment(event?.[0]?._d).startOf("day");
        const endDate = moment(event?.[1]?._d).startOf("day");

        setDateValue(event ? [startDate, endDate] : null);
        setFilterInput((prev) => ({
            ...prev,
            transactionStartDate: event ? new Date(startDate) : null,
            transactionEndDate: event ? new Date(endDate) : null,
            page: 1,
        }));
    };

    const handleCancel = () => {
        setErrorReason('')
        setCancel(true);
        let data = {
            gadai_id: id,
            notes: alasan,
        };
        if (IsEmpty(alasan)){
            setErrorReason('Alasan harus diisi')
        }else{
            let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up/decline`
            httpclient.POST(url, data).then((response) => {

                SwalToast.fire({
                    icon: "success",
                    title: response.data.message,
                });
                getData();
                setModalCancel(false);
                setSubmitting(false);
            }).catch((error) => {

                if (error.response) {
                    setCancel(false);
                    console.log(error.response.data.error);
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data.error.message,
                    });
                } else {
                    console.log(error);
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                    setCancel(false);
                }
            })
        }
    }

    // console.log(kurirList);

    const handleEdit = (record) => {
        setModalAdd(true);
        setDate(new Date(record.tanggal_jemput_submit));
        setAlamat(record.alamat);
        setOutletName(record.outlet_name);
        setKurir(record.kode_kurir);
        setId(record.kode_gadai);

    };


    const handleDetail = (record) => {
        setModalDetail(true);
        setCodeGadai(record.kode_gadai);
        setNamaNasabah(record.nama_nasabah);
        setNotelpNasabah(record.no_telp);
        setBarangJaminan(record.barang_jaminan);
        setWaktuJemput(record.waktu_jemput);
        setAlamatJemput(record.lokasi_jemput);
        setNamaKurir(record.nama_kurir);
        setTanggalJemput(record.tanggal_jemput_detail);
        setImage(record.gadai_picture);
        setNoImei(record.imei)

    };

    const handleCloseModal = () => {
    };

    const handleTableChange = (pagination, _, sorter) => {

        setFilterInput((prev) => ({
            ...prev,
            page: pagination.current,
            pageSize: parseInt(pagination.pageSize),
            sortingField: sorter?.column?.backend_key || null,
            sortingOrder:
                sorter?.order === "ascend"
                    ? "ASC"
                    : sorter?.order === "descend"
                        ? "DESC"
                        : null,
        }));
    };



    const handleFilterChanged = (e) => {
        const { value, name } = e.target;
        if (name === "pageSize") {
            setFilterInput((prev) => ({
                ...prev,
                pageSize: parseInt(value),
            }));
        }
        if (name === "name") {
            if (e.key === "Enter" || e.keyCode === 13) {
                setFilterInput((prev) => ({
                    ...prev,
                    searchName: value,
                }));
            }
        }
    };


    const getKurir = () => {
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/pick-up/master-data`;
        AxiosCustomGet(
            url,
            Config({
                Authorization: `Bearer ${Cookies.get("access_token")}`,
            }),
            (response) => {
                setLoading(false);
                setKurirList(
                    response.data.data.couriers.map((item) => ({
                        value: item.id,
                        label: `${item.first_name} ${item.last_name}`,
                        outlet: item.outlet.name,
                        // ...item,
                    }))
                );
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const handleSelectKurir = (e) => {
        setKurir({
            id: e.value,
            outlet: e.outlet
        });

    }

    return (
        <>
            <div>
                <div className="p-3">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <Title text="Jemput Gadai Terjadwal" />
                            <Breadcrumb current="Jemput Gadai Terjadwal" />
                        </div>

                        <div
                            style={{
                                padding: 13,
                                border: "1px solid #DCDCDC",
                                borderRadius: 5,
                                height: 50,
                                width: 200,
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 18,
                                    color: "#303030",
                                }}
                            >
                                <TiUser
                                    style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                                />
                                <span style={{ fontWeight: 700 }}>{totalRecords}</span> jadwal
                            </div>
                        </div>

                    </div>
                    <div className="d-flex pt-3 mt-2">
                        <div className="col-1 pl-0">
                            <div>Tampilkan</div>
                            <input
                                type="number"
                                id="show"
                                className="form-control border-A6A6A6 mt-1"
                                name="pageSize"
                                value={filterInput.pageSize}
                                onChange={handleFilterChanged}
                            />
                        </div>
                        <div className="mr-3">
                            <div>Nama Nasabah</div>
                            <input
                                type="text"
                                name="name"
                                className="form-control border-A6A6A6 mt-1"
                                placeholder="Cari"
                                onChange={handleFilterChanged}
                                onKeyDown={handleFilterChanged}
                            />
                        </div>
                        <div className="">
                            <CustomDatePicker
                                id={"TanggalJemput"}
                                label={"Tanggal Jemput"}
                                isRangePicker
                                width="60%"
                                onInputChange={handleDateChange}
                                value={dateValue}
                                height="36px"
                            />
                        </div>
                    </div>
                    <div className="mt-3">
                        <CustomTable
                            columns={renderColumns(handleEdit, handleDetail)}
                            data={records}
                            loading={loading}
                            handleTableChange={handleTableChange}
                            pagination={tablePagination}
                            scrollX={1800}
                        />
                    </div>
                </div>
            </div>
            <Modal
                className="modal-form"
                title="Ubah Jadwal"
                visible={modalAdd}
                disabled={submitting}
                onCancel={() => {
                    setModalAdd(false);
                }}
                footer={[
                    <Button
                        onClick={() => {
                            setModalCancel(true);
                            setModalAdd(false)
                            reset();
                        }}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 48,
                            color: "#fff",
                            background: "red",
                        }}
                    >
                        Batalkan
                    </Button>,
                    <Button
                        onClick={() => {
                            setModalAdd(false);

                        }}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 48,
                            color: "#000",
                            background: "#FFFFFF",
                        }}
                    >
                        Kembali
                    </Button>,
                    <Button
                        type="submit"
                        onClick={handleSubmit}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 48,
                            color: "#fff",
                            background: "#2C465C",
                        }}
                    >
                        Ubah
                    </Button>,
                ]}
            >

                <div>
                    <form>
                        <div className="row form-group align-items-center">
                            <div className="col-4">
                                <label className="form-label">Tanggal Jemput :</label>
                            </div>
                            <div className="col-8">
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={date}
                                    onChange={(date) => setDate(date)}
                                    className="form-control"
                                />
                            </div>
                            <IoCalendarOutline
                                style={{ fontSize: 20, marginLeft: -50, zIndex: 99 }}
                            />
                        </div>
                        <div className="row form-group align-items-center">
                            <div className="col-4">
                                <labe>Waktu Jemput :</labe>
                            </div>
                            <div className="col-8">
                                <DatePicker
                                    selected={date}
                                    onChange={(date) => setDate(date)}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="HH:mm"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="row form-group align-items-start">
                            <div className="col-4">
                                <labe>Alamat :</labe>
                            </div>
                            <div className="col-8">
                                <Input.TextArea
                                    required
                                    rows="6"
                                    type="text"
                                    className="form-control border-DCDCDC text-input"
                                    placeholder="Alamat outlet"
                                    defaultValue={alamat}
                                    value={alamat}
                                    onChange={(e) => setAlamat(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="row form-group align-items-center">
                            <div className="col-4">
                                <labe>Kurir :</labe>
                            </div>
                            <div className="col-8">
                                <Select
                                    name="kurir"
                                    options={kurirList}
                                    onChange={(e) => handleSelectKurir(e)}
                                    value={
                                        kurirList.find((e) => e.value === kurir?.id) || ""
                                    }
                                />
                            </div>
                        </div>
                        <div className="row form-group align-items-center">
                            <div className="col-4">
                                <label>Outlet :</label>
                            </div>
                            <div className="col-8">
                                <div style={{ flex: 2 }}>
                                    <p>{kurir?.outlet || "-"}</p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </Modal>

            <Modal
                centered
                title="Batalkan Proses Gadai"
                className="modal-form"
                visible={modalCancel}
                onCancel={() => {
                    setModalCancel(false);
                }}
                footer={[
                    <Button
                        onClick={() => {
                            setModalCancel(false);

                        }}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 48,
                            color: "#000",
                            background: "#FFFFFF",
                        }}
                    >
                        Kembali
                    </Button>,
                    <Button
                        onClick={() => {
                            handleCancel();
                        }}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 48,
                            color: "#fff",
                            background: "red",
                        }}
                    >
                        Batalkan
                    </Button>
                ]}
            >

                <div>
                    <form>
                        <div className="form-group">
                            <label>Berikan Alasan :</label>
                            <Input.TextArea
                                required
                                rows="6"
                                type="text"
                                className="form-control border-DCDCDC text-input"
                                placeholder="Alamat outlet"
                                defaultValue={alasan}
                                value={alasan}
                                onChange={(e) => setAlasan(e.target.value)}
                            />
                            <p className="text-danger small">{errorReason}</p>
                        </div>
                    </form>
                </div>

            </Modal>

            <Modal
                centered
                className="modal-detail"
                title="Detail Jemput Gadai"
                visible={modalDetail}
                onCancel={() => {
                    setModalDetail(false);
                }}
                footer={""}
            >
                <div>
                    <div
                        className="row flex-row flex-nowrap"
                        style={{ overflow: "auto", width: "500px" }}
                    >
                        {images.map((item) => (
                            
                        <GetImage
                            className="rounded mb-2 mr-2"
                            url={`gadai-product-picture/${item.id}/picture`}
                            style={{ width: "200px" }}
                        />

                        ))}
                        {/* </div> */}
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Kode Gadai" value={codeGadai || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Nama Nasabah" value={namaNasabah || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="No. Telepon Nasabah" value={notelpNasabah || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Barang Jaminan" value={barangJaminan || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Kondisi" value={kondisi || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="No. IMEI" value={noImei || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Tanggal Jemput" value={tanggalJemput || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Waktu Jemput" value={waktuJemput || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Alamat Jemput" value={alamatJemput || "-"} />
                    </div>
                    <div className="detail-header mb-3">
                        <TextInfo title="Kurir" value={namakurir || "-"} />
                    </div>
                </div>
            </Modal >
        </>
    );
}

